import { ref } from "vue";
import { defineStore } from "pinia";

export const useMaintenanceStore = defineStore("maintenance", () => {
  const isActive = ref(false);

  const activate = () => {
    isActive.value = true;
  };

  const reset = () => {
    isActive.value = false;
  };

  return {
    isActive,
    activate,
    reset,
  };
});
